import classnames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectGeoentityIconFromRouteOptions } from '../../store/poiassets/poiassets.selectors'
import SVGIcon from '../svg/SVGIcon'
import s from './SearchInputIcon.less'

function SearchInputIcon() {
  const { iconId, mob_roundImage } = useSelector(selectGeoentityIconFromRouteOptions)
  if (iconId) return <SVGIcon icon={iconId} className={classnames(s.common, s.icon)} />
  if (mob_roundImage) return <img src={mob_roundImage} className={classnames(s.common)} />
  return <></>
}

export default SearchInputIcon
